function CircleArrow({ width, height}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 715.542 559.079">
      <defs>
        <linearGradient id="linear-gradient" x2="1" y2="1" gradientUnits="objectBoundingBox">
          <stop offset="0" stopColor="#d1e2ff"></stop>
          <stop offset="1" stopColor="#f1e5ff"></stop>
        </linearGradient>
        <linearGradient
          id="linear-gradient-3"
          x1="0.973"
          x2="-0.004"
          y1="0.997"
          y2="0.106"
          gradientUnits="objectBoundingBox">
          <stop offset="0" stopColor="#fff"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="linear-gradient-4"
          x1="0.981"
          x2="0.021"
          y1="0.984"
          y2="0.047"
          gradientUnits="objectBoundingBox">
          <stop offset="0" stopColor="#fff"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0.078"></stop>
        </linearGradient>
      </defs>
      <g data-name="Group 8599" transform="translate(.379 -4578.249)">
        <circle
          cx="200"
          cy="200"
          r="200"
          fill="url(#linear-gradient)"
          data-name="Ellipse 120"
          opacity="0.8"
          transform="translate(227 4695)"></circle>
        <g data-name="contact us illustration-for dark" transform="translate(0 -72)">
          <g data-name="Group 5240">
            <path
              fill="none"
              stroke="#bdc4f5"
              strokeDasharray="10 10"
              strokeWidth="4"
              d="M.001 5207.364s320.923-61.849 401.075-164.061 8.518-169.272 62.642-231.286 133.752-79.552 133.752-79.552"
              data-name="Path 324"></path>
            <g transform="rotate(-16 17001.668 252.182)">
              <path fill="none" d="M0 0h104.894v104.894H0z" data-name="Path 228" transform="translate(0 -13.37)"></path>
              <path
                fill="url(#linear-gradient)"
                d="M.044 78.671l91.738-39.336L.044 0 0 30.594l65.559 8.741L0 48.077z"
                data-name="Path 227"
                transform="translate(8.741 -.258)"></path>
              <path
                fill="url(#linear-gradient-3)"
                d="M3.874 0l62.832 19.595L0 7.874z"
                data-name="Path 309"
                transform="rotate(-25 114.45 12.378)"></path>
              <path
                fill="url(#linear-gradient-4)"
                d="M3.721 0L69.4 73.755 0 7.283z"
                data-name="Path 310"
                transform="rotate(-25 5.68 -11.854)"></path>
            </g>
            <path
              fill="none"
              stroke="#fff"
              strokeWidth="1"
              d="M560.538 4704.939s-11.283 5.116-7.882 11.65 36.364-7.052 36.364-7.052"
              data-name="Path 325"
              opacity="0.3"></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default CircleArrow
